import { useMutation } from '@tanstack/react-query';

import { ChatResponse, SendConversationItemsRequest, sendConversationItems } from '~/services/AIChatService';

export function useSendConversationItems() {
  return useMutation<ChatResponse, Error, SendConversationItemsRequest>({
    mutationFn: sendConversationItems,
  });
}
